module.exports = __webpack_public_path__ + "img/sixpackcarrier28.dec6ef57.jpg";